export const modalDataSelector = state => state.common.modalData;
export const editableDataSelector = state => state.common.editableItem;

export const categoriesList = state => state.common.categories;

export const categoriesLoadingSelector = state => state.common.categoriesLoading;
export const currentRestaurantSelector = state => state.common.currentRestaurant;

// Visible lists selectors
export const visibleListsSelector = state => state.common.visibleLists;

// New selectors for the hooks
export const getModalData = (state) => state.common.modalData;
export const getCurrentRestaurant = (state) => state.common.currentRestaurant;
export const getEditableItem = (state) => state.common.editableItem;
export const getVisibleLists = (state) => state.common.visibleLists;
export const isListVisible = (state, listId) => state.common.visibleLists.includes(listId);
export const getHasEnteredMenu = (state) => state.common.hasEnteredMenu;
export const getCategories = (state) => state.common.categories;
export const getCategoriesLoading = (state) => state.common.categoriesLoading;
